export default {
  getMenu: () => {
    let array = [];
    let submenu = [];
    let submenu_incidents = [];
    let submenu_activities = [];
    let submenu_problems = [];
    let submenu_1 = [];
    let is_admin = window.GETCCMT.$store.state.is_admin();
    let is_manager = window.GETCCMT.$store.state.is_manager();
    let is_chargerClientele = window.GETCCMT.$store.state.is_chargerClientele();
    let is_client = window.GETCCMT.$store.state.is_client();
    let is_mandataire = window.GETCCMT.$store.state.is_mandataire();
    let is_dispatcher = window.GETCCMT.$store.state.is_dispatcher();
    let is_commercial = window.GETCCMT.$store.state.is_commercial()

    // /dashboard
    if (is_admin || is_manager || is_chargerClientele || is_client || is_mandataire || is_dispatcher || is_commercial) {
      array.push({
        url: "/dashboard",
        name: "Tableau de bord",
        slug: "home",
        icon: "HomeIcon"
      });
    }

    // Demandes
    submenu = [];
    submenu_incidents = [];
    submenu_activities = [];
    submenu_problems = [];


    if (is_admin || is_manager || is_chargerClientele || is_client || is_mandataire || is_dispatcher || is_commercial) {
      submenu.push({
        url: "/requests",
        name: "Toutes",
        slug: "all-requests"
      });
      submenu.push({
        url: "/requests-received",
        name: "Reçues",
        slug: "received-requests"
      });
      submenu.push({
        url: "/requests-in-progress",
        name: "En cours",
        slug: "in-progress-requests"
      });
      submenu.push({
        url: "/requests-closed",
        name: "Traitées",
        slug: "closed-requests"
      });
      submenu.push({
        url: "/requests-suspended",
        name: "Suspendues",
        slug: "suspended-requests"
      });
      submenu.push({
        url: "/requests-canceled",
        name: "Annulées",
        slug: "canceled-requests"
      });

      //incidents
      submenu_incidents.push({
        url: "/incidents",
        name: "Tous",
        slug: "all-incidents"
      });
      submenu_incidents.push({
        url: "/incidents-received",
        name: "Reçus",
        slug: "received-incidents"
      });
      submenu_incidents.push({
        url: "/incidents-in-progress",
        name: "En cours",
        slug: "in-progress-incidents"
      });
      submenu_incidents.push({
        url: "/incidents-closed",
        name: "Traités",
        slug: "closed-incidents"
      });
      submenu_incidents.push({
        url: "/incidents-suspended",
        name: "Suspendus",
        slug: "suspended-incidents"
      });
      submenu_incidents.push({
        url: "/incidents-canceled",
        name: "Annulés",
        slug: "canceled-incidents"
      });

      //activities
      submenu_activities.push({
        url: "/activities",
        name: "Toutes",
        slug: "all-activities"
      });
      submenu_activities.push({
        url: "/activities-received",
        name: "Reçues",
        slug: "received-activities"
      });
      submenu_activities.push({
        url: "/activities-in-progress",
        name: "En cours",
        slug: "in-progress-activities"
      });
      submenu_activities.push({
        url: "/activities-closed",
        name: "Traitées",
        slug: "closed-activities"
      });
      submenu_activities.push({
        url: "/activities-suspended",
        name: "Suspendues",
        slug: "suspended-activities"
      });
      submenu_activities.push({
        url: "/activities-canceled",
        name: "Annulées",
        slug: "canceled-activities"
      });

      //problems
      submenu_problems.push({
        url: "/problems",
        name: "Tous",
        slug: "all-problems"
      });
      submenu_problems.push({
        url: "/problems-in-progress",
        name: "En cours",
        slug: "in-progress-problems"
      });
      submenu_problems.push({
        url: "/problems-closed",
        name: "Traités",
        slug: "closed-problems"
      });

    }

    if (submenu.length) {
      array.push({
        url: null,
        name: "Demandes",
        icon: "MessageSquareIcon",
        submenu: submenu
      });
      array.push({
        url: null,
        name: "Incidents",
        icon: "AlertTriangleIcon",
        submenu: submenu_incidents
      });
      array.push({
        url: null,
        name: "Activités",
        icon: "ServerIcon",
        submenu: submenu_activities
      });
      array.push({
        url: null,
        name: "Problèmes",
        icon: "AlertTriangleIcon",
        submenu: submenu_problems
      });
    }


    if (is_admin || is_manager || is_chargerClientele || is_dispatcher) {
      // array.push({
      //   url: "/folders",
      //   name: "Dossiers",
      //   slug: "folders",
      //   icon: "FolderIcon"
      // })
    }

    if (is_admin) {
      array.push({
        url: "/third-party",
        name: "Third Party",
        slug: "thirdparty",
        icon: "LinkIcon"
      })
    }

    // Facturations
    submenu = [];

    if (is_chargerClientele || is_client || is_mandataire || is_manager) {
      submenu.push({
        url: '/invoices',
        name: "Factures",
        slug: ""
      });
    }

    if (is_chargerClientele || is_client || is_mandataire) {
      submenu.push({
        url: null,
        name: "Règlements",
        slug: ""
      });
    }

    submenu_1 = [];
    if (is_admin || is_manager || is_chargerClientele) {
      submenu_1.push({
        url: '/uploads/invoices',
        name: 'Factures',
        slug: ""
      }, {
        url: '/uploads/payments',
        name: 'Réglement',
        slug: ""
      });
    }

    if (is_chargerClientele) {
      submenu_1.push({
        url: '/uploads/payments',
        name: 'Règlements',
        slug: ""
      });
    }

    if (submenu_1.length) {
      submenu.push({
        url: null,
        name: "Uploads",
        submenu: submenu_1
      });
      submenu_1 = [];
    }

    if (submenu.length) {
      /*array.push({
        url: null,
        name: "Facturations",
        icon: "FileTextIcon",
        submenu: submenu
      });*/
    }

    // Statistiques
    submenu = [];

    if (is_dispatcher || is_admin || is_manager || is_chargerClientele) {
      submenu.push({
        url: '/statistics/globales',
        name: 'Globables',
        slug: "stat_req"
      })
      submenu.push({
        url: '/statistics/specifics',
        name: 'Spécifiques',
        slug: "statistics_ebu"
      })
    }

    if (submenu.length) {
      array.push({
        url: null,
        name: 'Statistiques',
        icon: 'ActivityIcon',
        submenu: submenu
      });
    }

    // profile
    if (is_admin || is_manager || is_chargerClientele || is_client || is_mandataire || is_dispatcher || is_commercial) {
      array.push({
        url: '/profile',
        name: 'Profil',
        icon: 'UserIcon',
      });
    }

    // Paramètres
    submenu = [];

    if (is_admin || is_dispatcher) {
      submenu.push({
        url: '/clients',
        name: 'Clients',
        slug: ""
      });
    }

    if (is_admin || is_dispatcher) {
      submenu.push({
        url: '/settings/admin',
        name: 'Paramètres Admin',
        slug: ""
      });
    }

    if (is_admin || is_dispatcher) {
      submenu.push({
        url: '/segments',
        name: 'segments',
        slug: ""
      });
    }
    if (is_admin || is_dispatcher) {
      submenu.push({
        url: '/services',
        name: 'Services',
        slug: ""
      });
    }

    if (is_admin || is_dispatcher) {
      submenu.push({
        url: '/approbations',
        name: 'Chaînes d\'approbations',
        slug: ""
      });
    }

    if (is_admin || is_dispatcher) {
      submenu.push({
        url: '/categories',
        name: 'Type de demandes',
        slug: ""
      });
    }

    if (is_admin || is_dispatcher) {
      submenu.push({
        url: '/types',
        name: 'Sous types de demandes',
        slug: ""
      });
    }

    if (is_admin || is_dispatcher) {
      submenu.push({
        url: '/users',
        name: 'Utilisateurs',
        slug: ""
      });
    }

    if (is_client) {
      submenu.push({
        url: '/settings/master',
        name: 'Paramètres Client Master',
        slug: ""
      });
    }

    /*
    if (is_manager) {
      submenu.push({
        url: '/settings',
        name: 'Paramètres Manager',
        slug: ""
      });
    }
    */

    if (submenu.length) {
      array.push({
        url: null,
        name: 'Paramètres',
        icon: 'SettingsIcon',
        submenu: submenu
      });
    }

    return array;
  }
}
